import React from "react";

import { IPets } from "../../interfaces/pets";
import { IUser } from "../../interfaces/user";
import { getAllUser } from "../../services/user.service";
import { useError } from "../../store/ErrorModal";

export default function useDatabaseUserPage() {
  const [dataForShow, setForShowData] = React.useState<IUser[]>([]);
  const [dataStorage, setDataStorage] = React.useState<IUser[]>([]);
  const [searchKey, setSearchKey] = React.useState<string>("");
  const [isShowModel, setIsShowModel] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [dataModal, setDataModal] = React.useState<IPets[]>([]);
  const { onError } = useError();

  const fetchData = React.useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await getAllUser();
      if (!res.data) return onError("มีบางอย่างผิดพลาด");
      setDataStorage(res.data);
      setForShowData(res.data);
    } catch (error) {
      onError(error as any);
    }
    setIsLoading(false);
  }, [onError]);
  const handleShowModalPets = (pets: IPets[]) => {
    setDataModal(pets);
    setIsShowModel(true);
  };
  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  React.useEffect(() => {
    if (!dataStorage || dataStorage.length === 0) return;
    const nData = dataStorage.filter((item) => {
      if (
        !item.firstName ||
        !item.lastName ||
        !item.displayName ||
        !item.phone ||
        !item.email ||
        item.petsName === undefined
      )
        return false;
      return (
        item.firstName.includes(searchKey) ||
        item.lastName.includes(searchKey) ||
        item.displayName.includes(searchKey) ||
        item.phone.includes(searchKey) ||
        item.email.includes(searchKey) ||
        item.petsName.includes(searchKey)
      );
    });
    setForShowData(nData);
  }, [searchKey, setSearchKey, dataStorage]);

  return {
    dataForShow,
    isShowModel,
    isLoading,
    dataModal,
    handleShowModalPets,
    setSearchKey,
    setIsShowModel,
  };
}
